import { Head, router } from "@inertiajs/react"

import AppLayout from "@/layouts/app-layout"
import type { BreadcrumbItem } from "@/types"

import ActivityForm from "./_form"

interface Option {
  id: number
  name: string
}
interface Activity {
  id: number
  title: string
  [key: string]: unknown
}
interface Props {
  activity: Activity
  activity_types: Option[]
  users: Option[]
  can_delete?: boolean
  errors?: Record<string, string[]>
}

export default function Edit({
  activity,
  activity_types,
  users,
  can_delete,
  errors,
}: Props) {
  const breadcrumbs: BreadcrumbItem[] = [
    { title: "Marketing Activities", href: "/marketing_activities" },
    {
      title: activity.title,
      href: `/marketing_activities/${activity.id}`,
    },
    { title: "Edit", href: `/marketing_activities/${activity.id}/edit` },
  ]

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title={`Edit ${activity.title}`} />
      <div className="p-6">
        <div className="mb-4 flex items-center justify-between">
          <h1 className="text-2xl font-semibold">Edit Marketing Activity</h1>
          {can_delete && (
            <button
              onClick={() => {
                if (confirm("Are you sure you want to delete this event?")) {
                  router.delete(`/marketing_activities/${activity.id}`)
                }
              }}
              className="bg-hpi-red rounded px-4 py-2 text-white hover:bg-red-700"
            >
              Delete
            </button>
          )}
        </div>
        <ActivityForm
          activity={activity}
          activityTypes={activity_types}
          users={users}
          errors={errors}
          isEdit
        />
      </div>
    </AppLayout>
  )
}
